import stringToNode from 'local/lib/stringToNode';

const links = document.querySelectorAll(`
	p a:not(.sambi-a-button):not(.o-footer__link),
	#siteMain li a:not(.sambi-a-button),
	#megaMenu li a:not(.sambi-a-button),
	td a:not(.sambi-a-button),
	th a:not(.sambi-a-button),
	.sambi-o-mega-menu a
`);

function isExternalUrl(link) {
	return /^(f|ht)tps?:\/\//i.test(link.href) && link.hostname !== window.location.hostname;
}

function isImageLink(link) {
	return link.querySelector('img') !== null;
}

function addExternalIcon(link) {
	link.appendChild(stringToNode(`
		<svg class="sambi-icon sambi-o-mega-menu__link__icon">
			<use xlink:href="#icon-external-link"></use>
		</svg>
	`));
}

[].forEach.call(links, (link) => {
	if (isExternalUrl(link) && !isImageLink(link)) {
		addExternalIcon(link);
	}
});
